module.exports = __webpack_public_path__ + "img/shrimp.42cd1182.png";